export default "__VITE_ASSET__BFvh2G6g__"